import { createAction } from 'typesafe-actions'
import { EstablishmentsActionTypes } from './types'
import { EstablishmentModel } from '../../../models/establishmentModel'

export const setEstablishment = createAction(
    EstablishmentsActionTypes.SET_ESTABLISHMENT,
)<EstablishmentModel>()
